import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param children
 */
const SummaryContainer = ({ children }) => {

    return (
        <div className="d-flex  align-content-center justify-content-center">
            <div className="content-center-w-600px">
                {children}
            </div>
        </div>
    );

}

export default SummaryContainer
